import { useTranslation } from 'react-i18next';

import {
	PrintPdfDialog,
	PrintPdfDialogProps,
} from 'modules/Shared/PdfPrint/PrintPdfDialog';

import { PrintProtocolDialogContent } from './ProtocolDialogContent';
import { PrintProtocolUserSettings, mapRecordToUserSettings } from './Types';
import { serviceProtocolPdfSettingsCategories } from './serviceProtocolSettingsCategory';

type PrintProtocolDialogContentProps = {
	isOffline: boolean;
};

type PrintProtocolDialogProps = Omit<
	PrintPdfDialogProps<
		PrintProtocolUserSettings,
		PrintProtocolDialogContentProps
	>,
	| 'ContentComponent'
	| 'mapRecordToPdfUserSettings'
	| 'pdfSettingsCategories'
	| 'title'
>;

export const PrintProtocolDialog = (props: PrintProtocolDialogProps) => {
	const { t } = useTranslation('serviceProtocol');

	return (
		<PrintPdfDialog
			ContentComponent={PrintProtocolDialogContent}
			mapRecordToPdfUserSettings={mapRecordToUserSettings}
			pdfSettingsCategories={serviceProtocolPdfSettingsCategories}
			title={t('protocolPrintout-info-title')}
			{...props}
		/>
	);
};
